/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchUploadRequestCostCarrierRequestDto,
  BatchUploadReviewCostCarriersPayload,
  CostCarrierBulkUpdateRequest,
  CostCarrierRequest,
  CostCarrierResponse,
  CsvReviewResponseCostCarrierRequestDto,
  GetAllByOrganisationParams4,
  GetAllPagedByOrganisationParams8,
  GetCostCarriersIdsByOrganisationWithoutPaginationParams,
  InfiniteScrollListCostCarrierResponseObject,
  ManagersUpdateRequestDto,
  ManagersUpdateResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCostCarrierController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name CreateCostCarrier
   * @request POST:/api/v1/cost-carrier
   */
  createCostCarrier = (data: CostCarrierRequest, params: RequestParams = {}) =>
    this.http.request<CostCarrierResponse, any>({
      path: `/v1/cost-carrier`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCostCarrierPath = '/v1/cost-carrier'
  static createCostCarrierMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name GetById
   * @summary Return cost-carrier by cost-carrier id
   * @request GET:/api/v1/cost-carrier/{costCarrierId}
   */
  getById = (costCarrierId: string, params: RequestParams = {}) =>
    this.http.request<CostCarrierResponse, any>({
      path: `/v1/cost-carrier/${costCarrierId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/cost-carrier/${costCarrierId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name UpdateCostCarrier
   * @request POST:/api/v1/cost-carrier/{costCarrierId}
   */
  updateCostCarrier = (
    costCarrierId: string,
    data: CostCarrierRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CostCarrierResponse, any>({
      path: `/v1/cost-carrier/${costCarrierId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCostCarrierPath = '/v1/cost-carrier/${costCarrierId}'
  static updateCostCarrierMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name DeleteCostCarrier
   * @request DELETE:/api/v1/cost-carrier/{costCarrierId}
   */
  deleteCostCarrier = (costCarrierId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/cost-carrier/${costCarrierId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteCostCarrierPath = '/v1/cost-carrier/${costCarrierId}'
  static deleteCostCarrierMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name UpdateManagers
   * @request POST:/api/v1/cost-carrier/managers
   */
  updateManagers = (data: ManagersUpdateRequestDto, params: RequestParams = {}) =>
    this.http.request<ManagersUpdateResponse, any>({
      path: `/v1/cost-carrier/managers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateManagersPath = '/v1/cost-carrier/managers'
  static updateManagersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name BulkUpdateCostCarriers
   * @request POST:/api/v1/cost-carrier/bulk-update
   */
  bulkUpdateCostCarriers = (data: CostCarrierBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/cost-carrier/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateCostCarriersPath = '/v1/cost-carrier/bulk-update'
  static bulkUpdateCostCarriersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name BatchUploadCostCarriers
   * @request POST:/api/v1/cost-carrier/batch-upload
   */
  batchUploadCostCarriers = (
    data: BatchUploadRequestCostCarrierRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/cost-carrier/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadCostCarriersPath = '/v1/cost-carrier/batch-upload'
  static batchUploadCostCarriersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name BatchUploadReviewCostCarriers
   * @request POST:/api/v1/cost-carrier/batch-upload/review
   */
  batchUploadReviewCostCarriers = (
    data: BatchUploadReviewCostCarriersPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponseCostCarrierRequestDto, any>({
      path: `/v1/cost-carrier/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewCostCarriersPath = '/v1/cost-carrier/batch-upload/review'
  static batchUploadReviewCostCarriersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name GetByIds
   * @summary Receive a list of cost-carrier ids separate by comma and returns a list of cost-carrier
   * @request GET:/api/v1/cost-carrier/{costCarrierIds}
   */
  getByIds = (costCarrierIds: string[], params: RequestParams = {}) =>
    this.http.request<CostCarrierResponse[], any>({
      path: `/v1/cost-carrier/${costCarrierIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdsPath = '/v1/cost-carrier/${costCarrierIds}'
  static getByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name GetAllPagedByOrganisation
   * @request GET:/api/v1/cost-carrier/paged
   */
  getAllPagedByOrganisation = (
    query: GetAllPagedByOrganisationParams8,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListCostCarrierResponseObject, any>({
      path: `/v1/cost-carrier/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllPagedByOrganisationPath = '/v1/cost-carrier/paged'
  static getAllPagedByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name GetAllByOrganisation
   * @request GET:/api/v1/cost-carrier/organisation
   */
  getAllByOrganisation = (query: GetAllByOrganisationParams4, params: RequestParams = {}) =>
    this.http.request<CostCarrierResponse[], any>({
      path: `/v1/cost-carrier/organisation`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllByOrganisationPath = '/v1/cost-carrier/organisation'
  static getAllByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-cost-carrier-controller
   * @name GetCostCarriersIdsByOrganisationWithoutPagination
   * @request GET:/api/v1/cost-carrier/organisation/all/ids
   */
  getCostCarriersIdsByOrganisationWithoutPagination = (
    query: GetCostCarriersIdsByOrganisationWithoutPaginationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/cost-carrier/organisation/all/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCostCarriersIdsByOrganisationWithoutPaginationPath =
    '/v1/cost-carrier/organisation/all/ids'
  static getCostCarriersIdsByOrganisationWithoutPaginationMethod = 'GET'
}
